import React from 'react'

import medal from '../../../../images/education/award.svg'
import hexagons from '../../../../images/education/hexagons.svg'
import gal from '../../../../images/education/galien.svg'

import styles from './styles.module.scss'
//
const OurMission = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <p className={styles.about_company}>Наша миссия</p>
        <p className={styles.number}>15</p>
        <p className='text-lg transition-all max-xxl:text-base'>
          лет на рынке
        </p>
        <p className={styles.number}>1700+</p>
        <p className='text-lg transition-all max-xxl:text-base'>
          сотрудников
        </p>
        <p className={styles.number}>80</p>
        <p className='text-lg transition-all max-xxl:text-base'>
        га территории биотехнопарка
        </p>
        <p className={styles.number}>61 000</p>
        <p className='text-lg transition-all max-xxl:text-base'>
        м&sup2; производственных мощностей
        </p>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>
            Наши идеи и достижения <br />для спасения жизни <br />и здоровья людей
          </p>
          <p className={styles.title_p1}>
            Generium — научно-производственная компания полного цикла. Наши сотрудники контролируют все этапы
            производства лекарственных препаратов: от создания молекул до промышленного выпуска.
          </p>
          <p className={styles.title_p2}>Мы занимаем лидирующие позиции в орфанном сегменте российского фармацевтического рынка. А новейшее научное оборудование, высокопрофессиональная команда и отлаженные процессы помогают нам добиваться признания и за рубежом.</p>
        </div>
        <div className={styles.information}>
          <div>
            <img src={hexagons} alt='icons' draggable='false' />
            <p>Более 60% препаратов компании - из орфанного сегмента</p>
          </div>
          <div className={styles.item2}>
            <img src={medal} alt='icons' draggable='false' />
            <p>
              В кратчайшие сроки обеспечили масштабирование и промышленный выпуск вакцины от COVID-19
            </p>
          </div>
          <div>
            <img src={gal} alt='icons' draggable='false' />
            <p>
              Премия Галена за разработку инновационного метода диагностики туберкулёза, получившего признание в ВОЗ
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurMission
